export default "__VITE_ASSET__DOg3U6JG__"